module.exports = __webpack_public_path__ + "img/cards.ecf2c8ad.png";